module.exports = __webpack_public_path__ + "static/img/logo-samu-192.51dfbc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-samu-192.png
// module id = UPg9
// module chunks = 4